<template>
  <div class="active-list-wrap">
      <!-- 头部 -->
      <top></top>
      <div class="banner">
          <img :src="$imgUrl + ad" alt="">
      </div>
      <div class="timenav"  v-if="timeList.length > 0">
          <div class="container">
              <Swiper :options="swiperOption"  class="activelist-swiper-container swiper-container">
                <SwiperSlide class="swiper-wrapper" v-for="(item, index) in timeList" :key="index" @click.native="changeTime(index,item.ymd)">
                    <div :class="[ timeCur == index ? 'cur' : '','activetitle']">{{item.d_m}}</div>
                </SwiperSlide>
            </Swiper>
          </div>
      </div>
      <el-row>
        <el-col :xs="1" :sm="3" :md="4" :lg="5" :xl="6"></el-col>
        <el-col :xs="22" :sm="18" :md="16" :lg="14" :xl="12">
            <div class="container alistwrap">
                <div class="submenu" v-if="classList.length > 0">
                    <Swiper :options="menuSwiperOption"  class="menulist-swiper-container swiper-container">
                        <SwiperSlide class="swiper-wrapper" @click.native="changeMenu(-1)">
                            <div :class="[ menuCur == -1 ? 'cur' : '','activetitle']" >{{$t('exhibitor.all')}}</div>
                        </SwiperSlide>
                        <SwiperSlide class="swiper-wrapper" v-for="(item, index) in classList" :key="index" @click.native="changeMenu(index,item.linkageid)">
                            <div v-if="langSet == 'zh' || item.description.length == 0" :class="[ menuCur == index ? 'cur' : '','activetitle']">{{item.name}}</div>
                            <div v-if="langSet == 'en' && item.description.length > 0" :class="[ menuCur == index ? 'cur' : '','activetitle']">{{item.description}}</div>
                        </SwiperSlide>
                    </Swiper>
                </div>
                <el-row :gutter="14" class="alist" v-if="activeList.length > 0">
                    <el-col class="alist-item" :span="8" v-for="item in activeList" :key="item.id" @click.native="toDetail(item.id)">
                        <img v-if="item.thumb.length > 0" :src="$imgUrl + item.thumb" alt="">
                        <img v-else src="../../../assets/active_default.jpg" alt="">
                        <div class="atext">
                            <p class="time">{{item.ymd}} {{item.time_1}}:{{item.time_2}}</p>
                            <p v-if="langSet == 'zh' || item.en_address.length == 0" class="address">{{item.address}}</p>
                            <p v-if="langSet == 'en' && item.en_address.length > 0" class="address">{{item.en_address}}</p>
                            <p v-if="langSet == 'zh' || item.en_title.length == 0" class="title">{{item.title}}</p>
                            <p v-if="langSet == 'en' && item.en_title.length > 0" class="title">{{item.en_title}}</p>
                            <p class="detail">{{$t('exhibitor.activeDetails')}} ></p>
                        </div>
                    </el-col>
                </el-row>
                <el-pagination
                    v-if="activeList.length > 0"
                    background
                    layout="total,prev, pager, next"
                    @current-change="changePage"
                    :total="total">
                </el-pagination>
                <div class="nodata" v-if="activeList.length == 0">
                    <div v-if="langSet == 'zh'" style="font-size:20px;text-align:center">
                            敬请期待
                    </div>
                    <div v-else>
                            Coming Soon
                    </div>
                    <!-- <img v-if="langSet == 'zh'" src="../../../assets/nodata.png" alt="">
                    <img v-else src="../../../assets/nodata01.png" alt=""> -->
                </div>
            </div>
        </el-col>
        <el-col :xs="1" :sm="3" :md="4" :lg="5" :xl="6"></el-col>
      </el-row>
      <!-- 底部 -->
      <bottom></bottom>
  </div>
</template>

<script>
import top from "../../../components/top.vue";
import bottom from "../../../components/bottom.vue";
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { getActivitytime, getActivityclass, getActivityitem, getBanner } from "@/api/api";
export default {
    components: { top, bottom, Swiper, SwiperSlide},
    name: "active",
    data() {
        return {
            page: 1,
            timeList:[],
            timeCur:0,
            classList:[],
            menuCur:-1,
            activeList: [],
            swiperOption: {
                slidesPerView: 4,
                spaceBetween: 10,
            },
            menuSwiperOption: {
                slidesPerView: 'auto',
                spaceBetween: 10,
                grabCursor: true,
            },
            total: 0,
            ad: '',
            langSet: ''
        };
    },
    created() { 
    },
    mounted() {
        this.langSet = localStorage.getItem('languageSet') || 'zh';
        this.classid = this.$route.query.classid;
        this.getTime(this.page,this.classid);
        this.getClass();
        this.getTopBanner();
     },
    methods: {
        //精彩活动时间
        getTime(page,classid){
            let data = this.$qs.stringify({
                page, 
                classid
            })
            getActivitytime(data).then(res=>{
                if(res.data.errno == 0){
                    this.timeList = res.data.rst
                    if(this.timeCur == 0){
                        this.ymd = res.data.rst[0].ymd;
                        //console.log(this.ymd)
                        this.getActivitylist(this.page,this.classid,this.ymd)
                    }else{
                        this.getActivitylist(this.page,this.classid,this.ymd, '')
                    }
                }
            }).catch(err=>{
                console.log(err)
            })
        },
        //精彩活动分类
        getClass(){
            let data = this.$qs.stringify({
                keyid: '3678'
            })
            getActivityclass(data).then(res=>{
                if (res.status == 200) {
                    this.classList = res.data;
                }
            }).catch(err=>{
                console.log(err)
            })
        },
        //头部广告图
        getTopBanner(){
            let data = this.$qs.stringify({
                cid: 9
            })
            getBanner(data).then(res=>{
                //console.log(res)
                if (res.status == 200) {
                    if(res.data.rst.length > 0){
                        this.ad = res.data.rst[0].imgurl;
                    }
                }
            }).catch(err=>{
                console.log(err)
            })
        },
        //精彩活动列表
        getActivitylist(page, classid, ymd, type){
            if(ymd){
                let data = this.$qs.stringify({
                    page, classid, ymd, type
                })
                getActivityitem(data).then(res=>{
                //console.log(res.data)
                if(res.data.errno == 0){
                    var resData=[];
                    res.data.rst.map((item)=>{
                        if(item.status=='1'){
                            resData.push(item);
                        }
                    })
                    this.activeList = resData;
                    // this.total = Number(res.data.errmsg);
                    this.total = this.activeList.length;
                }
                }).catch(err=>{
                    console.log(err)
                })
            }            
        },
        changePage(val){
            this.page = val;
            this.getActivitylist(this.page);
        },
        changeTime(index,ymd){
            this.timeCur = index;
            //console.log(ymd)
            this.getActivitylist(this.page,this.classid,Number(ymd))
        },
        changeMenu(index,linkageid){
            this.menuCur = index;
            //console.log(linkageid)
            if(index == -1){
                this.getActivitylist(this.page,this.classid,Number(this.ymd), '')
            }else{
                this.getActivitylist(this.page,this.classid,Number(this.ymd), linkageid)
            }
        },
        toDetail(id){
            // if(!this.$store.state.isLogin){
            //     this.$router.push({path: '/login'});
            //     return false;
            // }
            this.$router.push({path: '/activedetail',query:{id}});
        }
    }
}
</script>

<style lang="scss" scoped>
.active-list-wrap{
    .banner{
        width:100%;height:282px;
        img{width:100%;height:100%;display: block;}
    }
    .timenav{
        height:80px;line-height: 80px;background: #F2F2F2;width: 100%;padding: 0 25%;box-sizing: border-box;
        .cur{color: #CAC28A;}
        .cur::after{content: '';position: absolute;left: 50%;bottom: 0;width:122px;height:4px;background:#CAC28A;transform: translateX(-50%);}
    }
    .activelist-swiper-container .activetitle{font-size:26px;color:#000;font-weight: bold;cursor: pointer;width: 100%;height: 100%;position: relative;}
    .nodata{padding: 150px 0;}
} 
.alistwrap{
    padding: 20px 0 67px;
    .alist{
        .alist-item{padding-bottom: 20px;cursor: pointer;}
        img{width: 100%;height:165px;border-radius:9px;}
        .atext{
            .time{font-size: 20px;line-height:28px;color: #000;}
            .address{font-size: 14px;line-height:20px;color: #333;}
            .title{font-size: 18px;line-height:20px;color: #333;height: 38px;overflow: hidden;font-weight: bold;}
            .detail{font-size: 14px;line-height:20px;color: #CAC28A;cursor: pointer;}
        }
    }
}
.alistwrap .el-pagination{text-align: center;background: #EEE;padding: 6px 5px;height: 52px;box-sizing: border-box;}
.alistwrap .el-pagination button, .alistwrap .el-pagination span:not([class*=suffix]){height: 36px;line-height: 40px;font-size:18px;color: #666;}
.alistwrap .el-pager li{font-size: 18px;color: #666;}
.alistwrap .el-pagination.is-background .btn-next, .alistwrap .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{background-color:#fff;border-radius: 50%;}
.alistwrap .el-pagination.is-background .el-pager li{width: 41px;height: 41px;line-height: 41px;}
.alistwrap .el-pagination.is-background .el-pager li:not(.disabled).active,.alistwrap .el-pager li.active{background-color:#CAC28A;color: #fff !important;}
.alistwrap .el-pagination.is-background .btn-next, .alistwrap .el-pagination.is-background .btn-prev{background-color: transparent;}
.alistwrap .el-pagination .btn-next .el-icon, .alistwrap .el-pagination .btn-prev .el-icon{font-size: 20px;}
.alistwrap .el-pagination.is-background .el-pager li:not(.disabled):hover{color:#CAC28A;}
.menulist-swiper-container {
    margin-bottom: 46px;
    .swiper-slide{width: auto;}
    .activetitle{font-size:20px;line-height: 28px;cursor: pointer;}
    .cur{color: #CAC28A;}
}

@media only screen and (max-width: 767px){
    .active-list-wrap{
        .banner{height: 100%;}
        .activelist-swiper-container .activetitle{font-size: 18px;}
        .timenav{
            height: 0.8rem;line-height: 0.8rem;padding: 0 0.2rem;
            .cur::after{width: 100%;}
        }
    } 
    .menulist-swiper-container{
        margin-bottom: 0.4rem;
        .activetitle{font-size: 16px;}
    }
    .alistwrap{
        padding: 0.2rem 0 0.67rem;
        .alist-item{width: 100%;}
        .alist img{height: 3.3rem;}
    }
    .alistwrap .el-pagination{height: 0.52rem;padding:0.05rem;}
    .alistwrap .el-pagination button, .alistwrap .el-pagination span:not([class*=suffix]){height: 0.36rem;line-height: 0.36rem;font-size: 12px;}
    .alistwrap .el-pagination.is-background .el-pager li {width: 0.41rem;height: 0.41rem;line-height: 0.41rem;}
    .alistwrap .el-pager li{font-size: 12px;}
    .el-pager, .el-pager li{vertical-align: middle;}
    .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{min-width: auto;}
    .alistwrap .el-pagination .btn-next .el-icon, .alistwrap .el-pagination .btn-prev .el-icon{font-size: 18px;}
}
</style>